import type { ReactNode } from 'react';
import clsx from 'clsx';

export type Tone = 'neutral' | 'brand' | 'success' | 'danger' | 'warning' | 'info' | 'pending' | 'muted';

// Figma UI kit, Badges & Tags (node 1:1018): neutral = feature tag, brand = CRITICAL tag, the rest = status badges.
const tones: Record<Tone, string> = {
  neutral: 'bg-surface text-fg ring-1 ring-border ring-inset',
  brand: 'bg-primary-subtle text-primary ring-1 ring-primary ring-inset',
  success: 'bg-success-subtle text-success',
  danger: 'bg-danger-subtle text-danger-text',
  warning: 'bg-warning-subtle text-warning',
  info: 'bg-info-subtle text-link',
  pending: 'bg-pending-subtle text-fg',
  muted: 'bg-neutral-subtle text-fg-muted',
};

export function Badge({ tone = 'neutral', children, className, icon }: { tone?: Tone; children: ReactNode; className?: string; icon?: ReactNode }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-full px-3 py-[5px] text-[11px]/[16.5px] font-semibold tracking-label whitespace-nowrap uppercase',
        tones[tone],
        className,
      )}
    >
      {icon}
      {children}
    </span>
  );
}
